export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENTID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANTID}`,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};
